import React from 'react';
import InitiativeItemTemplate from './Initiatives/InitiativeItemTemplate';
import StrategicImperativeItemTemplate from './StrategicImperatives/StrategicImperativeItemTemplate';
import UserItemTemplate from './Users/UserItemTemplate';
import UserTriggerItems from './Users/UserTriggerItems';

export const InitiativesSelectroV2Templates = {
  item: InitiativeItemTemplate,
};

export const StrategicImperativesSelectroV2Templates = {
  item: StrategicImperativeItemTemplate,
};

export const UsersSelectroV2Templates = {
  item: UserItemTemplate,
  triggerItems: () => <UserTriggerItems />,
};
